export const diyProcesses = [
  {
    id: 'affidavits-declarations',
    title: "Author Declarations, Affidavits, Notifications, and Recordings",
    description: "Understand the importance of making statements from the deepest part of your soul, and then letting everyone know whom you have declared yourself to be.",
    timeEstimate: "24 hours",
    documents: 2,
    path: "/diy/affidavits-declarations"
  },
  {
    id: 'status-correction-passport',
    title: "Correct your Political Status via DS-11 Passport Application",
    description: "Complete guide to correct your political status and obtain proper non-citizen national identification outside the federal jurisdiction of UNITED STATES corporation.",
    timeEstimate: "instant",
    documents: 3,
    path: "/diy/status-correction-passport"
  },
  {
    id: 'tax-liability-removal',
    title: "Zero your Current Tax Liability with the IRS",
    description: "Remove yourself from the U.S. Corporation once and for all and obliterate instantaneously the tax liability you thought you had.",
    timeEstimate: "3-5 weeks",
    documents: 3,
    path: "/diy/tax-liability-removal"
  },
  {
    id: 'trust-estate-establishment',
    title: "Estate Planning with Private Trusts. Never Be Taxed again",
    description: "Comprehensive process for establishing your private trust structures. Move privately and independent of unnecessary external control of whats rightfully yours.",
    timeEstimate: "1 day - 4 weeks",
    documents: 4,
    path: "/diy/trust-estate-establishment"
  },
  {
    id: 'foreign-trust-ein',
    title: "Acquire 98 Series EIN for Foreign Grantor Trust",
    description: "Obtain the proper federal identification number for your foreign trust entity, establishing recognition while maintaining private status.",
    timeEstimate: "1 hr",
    documents: 1,
    path: "/diy/foreign-trust-ein"
  },
  {
    id: 'private-transportation-authority',
    title: "Establish Private Transportation Authority",
    description: "Establish a relationship with the federal government in order that they not interfere with your private right to move upon the land.",
    timeEstimate: "one hour",
    documents: 1,
    path: "/diy/private-transportation-authority"
  },
];

export type DIYProcess = typeof diyProcesses[0];